import { Modal } from 'antd';

/**
 * Promise-wrapped AntD confirm — the project-standard replacement for
 * `window.confirm` (native dialogs block the event loop, look alien next to
 * the app's popups and can't be styled/localized). OK/Cancel button labels
 * come from the antd locale configured at boot (`src/index.tsx`).
 */
export const confirmModal = (
  content: string,
  title?: string,
): Promise<boolean> =>
  new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
